'use client';

import { useState, useEffect } from 'react';
import { usePathname } from 'next/navigation';
import programModules from '@/data/programModules';

export default function ProgramModules() {
  const [moduleData, setModuleData] = useState(null);
  const [expandedModule, setExpandedModule] = useState(null);
  const pathname = usePathname();

  useEffect(() => {
    // Extract the slug based on the path pattern
    let slug;
    const pathParts = pathname.split('/').filter(part => part);
    
    // Check if it's a workshop path
    if (pathParts[0] === 'workshops') {
      // For workshop paths, use format "workshops/[slug]"
      slug = `workshops/${pathParts[1]}`;
    } else {
      // For regular paths, just use the last part as the slug
      slug = pathParts[pathParts.length - 1];
    }
    
    // Find matching program modules
    const matchingProgram = programModules.find(program => program.slug === slug);
    
    if (matchingProgram) {
      setModuleData(matchingProgram.modules);
    } else {
      // Fallback to first program if no match found
      setModuleData(programModules.length > 0 ? programModules[0].modules : null);
    }
  }, [pathname]);

  const toggleModule = (moduleNumber) => {
    if (expandedModule === moduleNumber) {
      setExpandedModule(null);
    } else {
      setExpandedModule(moduleNumber);
    }
  };

  if (!moduleData) {
    return null;
  }

  return (
    <div className="mt-20">
      <h2 className="text-[#002726] text-2xl md:text-[32px] font-medium mb-6">What will you learn?</h2>
      
      <div className="space-y-4">
        {moduleData.map((module) => (
          <div 
            key={module.moduleNumber}
            className="border border-[rgba(0,39,38,0.2)] rounded-2xl overflow-hidden"
          >
            <button 
              onClick={() => toggleModule(module.moduleNumber)} 
              className="w-full flex items-center justify-between p-6 text-left focus:outline-none"
            >
              <div>
                <p className="text-[#002726] text-sm font-normal">MODULE {module.moduleNumber}</p>
                <h3 className="text-[#002726] text-lg md:text-base font-medium">{module.heading}</h3>
              </div>
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
                className={`transform transition-transform ${expandedModule === module.moduleNumber ? 'rotate-180' : ''}`}
              >
                <path d="M6 9L12 15L18 9" stroke="#002726" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            
            {expandedModule === module.moduleNumber && (
              <div className="px-6 pb-6">
                <p className="text-[#002726] text-base font-normal">{module.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}